<template>
  <CustomCallout
    :has-toggle="false"
    border-color="gray"
    :class-main="isMobile ? 'p-2' : 'p-2 pb-3'"
    class="mt-2"
  >
    <div class="row">
      <div class="col-14 col-md">
        <span class="text-title">
          Año Académico:
        </span>

        <div class="text-title regular text-black">
          <span>{{ academicYear }}</span>
        </div>
      </div>

      <div class="col-12 col-md">
        <span class="text-title">
          Región:
        </span>

        <div class="text-title regular text-black">
          <span>{{ region }}</span>
        </div>
      </div>

      <div class="col-12 col-md">
        <span class="text-title">
          Municipio:
        </span>

        <div class="text-title regular text-black">
          <span>{{ municipality }}</span>
        </div>
      </div>

      <div class="col-12 col-md-3">
        <span class="text-title">
          Escuela:
        </span>

        <div class="text-title regular text-black">
          <span>{{ school }}</span>
        </div>
      </div>

      <div class="col-6 col-md">
        <span class="text-title">
          Total de Asistentes:
        </span>

        <div class="text-title regular text-black">
          <span>{{ quantity }}</span>
        </div>
      </div>

      <div class="col-12 col-md text-right">
        <ActionButton
          :class="{
            'btn-block mt-2': isMobile,
            'ml-auto': !isMobile,
          }"
          i="fas fa-file-import pr-1"
          variant="outline-success btn-transparent"
          @click="manageServiceAssistant"
        >
          Entrar
        </ActionButton>
      </div>
    </div>
  </CustomCallout>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from '@/components/common/ActionButton';

export default {
  name: 'SearchResultRow',
  components: { CustomCallout, ActionButton },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    model() {
      return this.value;
    },
    academicYear() {
      return this.model.academicYear.name;
    },
    region() {
      return this.model.region.name;
    },
    municipality() {
      return this.model.municipality.name;
    },
    school() {
      return this.model.school.name;
    },
    quantity() {
      return this.model.quantityAssistant;
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  methods: {
    async manageServiceAssistant() {
      this.$router.push({
        name: 'ManageServiceAssistant',
        params: {
          schoolId: this.model.school.id,
          academicYearId: this.model.academicYear.id,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.btn-transparent {
  background: transparent;
}
</style>
